<h2 mat-dialog-title class="bgDialogHeader text-center">Mileage/Hours History
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <div class="driverDetaisDiv">
    <div class="row">
      <div class="col-12">
        <div class="col-12 mt-2">
          <button class="btn btn-semi-round bgBlue pull-right col-12 col-sm-6 col-md-3 m-1"
            (click)="showUpdateDialog()">Update Meter Readings</button>
          <button class="btn btn-semi-round bgBlue pull-right col-12 col-sm-6 col-md-3 m-1">Refresh Inspections</button>
        </div>
      </div>
    </div>
    <div class="row mt-3 table-scroll">
      <ng2-smart-table [settings]="settings" [source]="data"></ng2-smart-table>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="btn btn-semi-round bgBlue pull-right"> Close </button>
</mat-dialog-actions>
